import { z } from 'zod'

export const clearPresentationNotificationSchema = z.object({
  presentationId: z.string().uuid(),
})
export type ClearPresentationNotification = z.infer<
  typeof clearPresentationNotificationSchema
>
